type keyValueType = {
  [key: string]: string[];
};

export const sortByGroupName = (items: string[]): string[] => {
  const createGroupByModule = (acc: keyValueType, item: string) => {
    const [_, module] = item.split(':');

    return {
      ...acc,
      [module]: acc[module] ? [...acc[module], item] : [item],
    };
  };

  const generateArrayFromObject = (acc: string[], items: string[]) => [
    ...acc,
    ...items,
  ];

  const group = items.reduce(createGroupByModule, {});
  return Object.values(group).reduce(generateArrayFromObject, []);
};
